import { z } from '@/libs/zod';

export const WithdrawStatus = z.enum(['PENDING', 'APPROVED', 'COMPLETED', 'REJECTED']);

export const WithdrawReason = z.enum([
  'REQUEST_WITHDRAWAL',
  'WON_MAIN_PRIZE',
  'WON_INSTANT_PRIZE',
  'WON_SCRATCHER_PRIZE',
  'PURCHASE_BY_BALANCE',
  'REFUND',
  'DEPOSIT_PENDING',
  'DEPOSIT_APPROVED',
]);
